/*
 * @Author: your name
 * @Date: 2022-02-26 13:43:59
 * @LastEditTime: 2024-08-02 10:02:02
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \kares_pad\src\i18n\language\en-US.js
 */
import en from './yh_en'

export default {
  // 主页
  home: {
    describe1: 'Welcome to use',
    describe2: 'Make the world just a fingertip away',
    describe3: 'With perfect cross-platform solutions, it is based on network platform and adopts distributed regional management technology, which can effectively integrate various multimedia resources and achieve remote production, release and management of programs.',
  },
  app: {
    more: 'View More',
    PersonalCenter: 'Personal Center',
    HelpDocument: 'Help Document',
    LogOut: 'LogOut',
    AddMaterial: 'Add Material',
    CreateProgram: 'Create Program',
    CreateRelease: 'Create Release',
    AddTerminal: 'Add Terminal',
    CreateAccount: 'Create Account',
    Percent: 'Percent',
    TerminalName: 'Terminal Name',
    ReleaseSchedule: 'Release Schedule',
    status: 'Status',
    operate: 'Operate',
    retransmission: 'Rtns',
    Cancel: 'Cancel',
    CancelAll: 'CancelAll',
    AllRetransmission: 'All Re-TXS',
    ClearanceToComplete: 'Clear Complete',
    RemoveAll: 'Remove All',
  },
  // 基础组件
  basics: {
    ...en.basics,
    materialCatalogue: 'Material Catalogue',
    structureGrouping: 'Structure Grouping',
    inStreamType: 'In-stream type',
  },
  public: {
    search: 'Please enter query keyword!',
  },
  // 页面路由
  router: {
    // 帮助
    help: 'Help',
    // 素材管理
    material: 'Material',
    // 节目管理
    programme: 'Programme',
    editProgramme: 'Edit Programme',
    publishProgramme: 'Publish Programme',
    // 终端管理
    terminal: 'Terminal',
    // 审核管理
    check: 'Check',
    checkMaterial: 'Material',
    checkProgramme: 'Programme',
    checkPublish: 'Publish',
    // 日志管理
    log: 'Device Login',
    logLogin: 'Login',
    logOperation: 'Operation',
    logTerminal: 'Terminal',
    // 高级管理
    seniorManagement: 'Senior Management',
    organization: 'Organization',
    userManage: 'User',
    RoleManage: 'Role',
    systemLayout: 'System Layout',
    nodeManage: 'Node Manage',
    reviewSet: 'Review Set',
    softwareLicence: 'Software Licence',
  },
  device: {

  },
  explorer: {
    clickUpload: 'Drag files to here, or <em>click to Upload</em>',
    sizeLimit: 'Single File Not Exceed ',
    video: 'Video',
    picture: 'Picture',
    uploadFiles: 'Upload files',
    newFolder: 'New folder',
    deleteFiles: 'Delete files',
    materialAll: 'All materials loaded',
    materialsLoaded: 'Click to load material',
    move: 'Move',
    copy: 'Copy',
    delete: 'Delete',
    all: 'All',
    name: 'Name',
    resolution: 'Resolution',
    fileSize: 'FileSize',
    creationTime: 'Creation Time',
    operate: 'Operate',
    FolderName: 'FolderName',
    deleteFile: 'IF delete currently selected file?',
    BackEdit: 'Back to program edit',
    FileMove: 'File Move',
    FileCopy: 'File Copy',
    StartAll: 'Start All',
    StopAll: 'Stop All',
    EmptyFinish: 'Empty Finish',
    CancelAll: 'Cancel All',
    NoFiles: 'No uploaded files yet',
    Status: 'Status',
    Check: 'Check',
    Stop: 'Stop',
    Start: 'Start',
    Cancel: 'Cancel',
    finish: 'finish',
  },
  log: {
    export: 'Export',
    selectDevice: 'Select device',
    deviceSn: 'Device SN',
    operateTime: 'Operate time',
    operateUser: 'Operate user',
    function: 'Function',
    describe: 'Describe',
    dateArr: 'Date range',
    startDate: 'Start date',
    endDate: 'End date',
    search: 'Please enter query keyword!',
    searchTips: 'Select a device to inquire',
    loadingTips: 'The log is being acquired, please wait',
    no: 'Coding',
    content: 'Content',
    operateObj: 'Operation object',
    operateContent: 'Operation information',
    selectTips1: 'Only supports query data within three months',
    searchTips1: 'Please select a terminal first, determine the time range, and query',
    exportTips: 'Only data within query time range can be exported',
  },
  login: {
    Login: 'Login',
    memberRegister: 'Member register',
    ForgetThePassword: 'Forget the password?',
    NoLogin: 'No login for seven days',
    verification: 'Please enter the verification code',
    account: 'Please enter your account',
    password: 'Please enter password',
    helpDocument: 'Help' // help document
  },
  manage: {

  },
  review: {
    ...en.review,
    review: 'Review',
    enterKey: 'Please enter key words',
    screenshot: 'Screenshot',
    name: 'Name',
    group: 'Mechanism',
    createTime: 'Submission time',
    publisher: ' Publisher',
    operate: 'Operate',
    check: 'Check',
    pass: 'Approved',
    reject: 'Reject',
    materialCheck: 'Material review',
    pleaseInputContent: 'Please enter review content',
    approve: 'Approved',
    rejectReview: 'Reject review',
    releaseReview: 'Release review',
    resonForReject: 'Please enter reason for rejection',
    all: 'All',
    waitReview: 'Pending review',
    approves: 'Pass',
    selectTips: 'Please select at least one material',
    selectTips1: 'Only supports query data within three months',
    deleteTips: 'Are you sure to delete all?',
    singleNo: 'Single number',
    loop: 'Loop',
    timming: 'Timing',
    instream: 'In-stream',
    noAdap: 'Not adaptive',
    adap: 'Adaptive screen size',
  },
  schedule: {
    ...en.schedule,
    loop: 'Loop',
    timpingPlay: 'Timing play',
    emerPlay: 'Emergency inter-cut',
    releaseRecord: 'Release record',
    releaseMan: 'Release management',
    playNo: 'Release number',
    group: 'Mechanism',
    releaseType: 'Release type',
    releaseNow: 'Release now',
    releaseTim: 'Release time',
    publisher: ' Publisher',
    review: 'Review',
    pedReview: 'Pending review',
    noReview: 'No review',
    noPass: 'Not pass',
    pass: 'Approved',
    waitRelease: 'Wait for release',
    expird: 'Expired',
    operate: 'Operate',
    detail: 'Details',
    delete: 'Delete',
    deletePlay: 'Delete  program',
    deletePlayTip: 'Permanently delete the currently selected program?',
    keyWords: 'Please enter a query keyword',
    noSelectTip: 'No release records selected',
    addPlay: 'Add program',
    selectProgram: 'Select program list',
    delPro: 'Delete Program',
    delProTip: 'Do you want to clear all programs?',
    screenshot: 'Screenshot',
    proName: 'Program name',
    structure: 'Structure',
    resolution: 'Resolution',
    createTime: 'Submission time',
    noProgram: 'Currently no programs',
    moveDown: "Can't move down any further",
    moveUp: "Can't move up any further",
    tips: 'Tip',
    playList: 'Program list',
    terminalList: 'Terminal list',
    releaseProp: 'Release properties',
    offline: 'Offline',
    timimgPlan: 'Timing Release',
    user: 'User',
    terminalName: 'TerminalName',
    terminalState: 'Device status',
    publishSate: 'Release status',
    planModole: 'Play mode',
    playStrategy: 'Release strategy',
    playPlan: 'Play plan',
    playCount: 'Times of play',
    playsCount: 'Number of consecutive plays',
    pleaseSelect: 'Please select',
    playTimes: 'Play time',
    conPlayTime: 'Continuous play time',
    publish: 'Release',
    customize: 'Customize',
    once: '1',
    twice: '2',
    treeTimes: '3',
    fourTimes: '4',
    fiveTimes: '5',
    sixTimes: '6',
    sevenTimes: '7',
    eightTimes: '8',
    nineTimes: '9',
    tenTimes: '10',
    countTips: 'The number of times must be at least 1',
    pubSuccessTip: 'Release success',
    selectTip1: 'Please select at least two programs',
    planPre: 'Program preview',
    addPlayStep: 'Add plan steps',
    selectDate: 'Select date time',
    instreamResver: 'Stream Reserve',
    instreamNow: 'Stream Now',
    selectTimeTips: 'The selection time cannot be earlier than the current time',
    palyTime: 'Play time',
    selectStartTime: 'Select a Start Time',
    selectEndTime: 'Select an End Time',
    conserLoop: 'Number of consecutive loop',
    validDate: 'Valid Date',
    date: 'Date',
    daily: 'Daily',
    startTimeTips: 'Start time cannot later than end time',
    endTimeTips: 'End time cannot earlier than start time',
    startDateTips: 'Start date cannot be later than end date',
    endDateTips: 'End date cannot earlier than start date',
    saveAplan: 'Keep one plan at least',
    check: 'Check',
    planSize: 'Program Size',
    planName: 'Release Name',
    leastTime: 'Invalid date',
    NewProgramInfor: 'New Program Infor' //New Program Infor
  },
  system: {
    ...en.system,
    clearTips1: 'Whether to clear all current reviewers?',
    clearTips2: 'Whether to clear current reviewer?',
    selectReviewer: 'Select Reviewers',
    noReviers: 'For those who do not have relevant review permissions,',
    createTips: 'please create an review account first',
    sameReviwers: 'The Next organization shares the same reviewer',
    email: 'Mail',
    lastLogin: 'Last login',
    resetPwd: 'Reset Password',
    subUser: 'Subordinate users',
    NumOfTerminals: 'Number of terminals',
    NumOfPro: 'Number of programs',
    editPwd: 'Change Password',
    oriPwd: 'Original password',
    newPwd: 'New password',
    confirmPws: 'Confirm password',
    modifyInfo: 'Modify Information',
    changeNick: 'Change Nickname',
    changeEmail: 'Change Email',
    personalCenter: 'Personal Center',
    enterOriPwd: 'Enter Original Password',
    enterNewPwd: 'Enter New Password',
    confirmPwd: 'Please Confirm Password',
    enterNick: 'Please Enter Nickname',
    pwdNoPass: 'Password Twice Inconsistent',
    changePwdSucc: 'Change password success',
    modiSuccess: 'Modified success',
    modiFail: 'Modified fail',
    noSet: 'Is not set',
    PleaseInputEmail: 'Please enter the Email',
  },
  terminal: {
    treeTitle: 'Structure grouping',
    Details: 'Details',
    online: 'Online',
    offline: 'Offline',
    list: 'List',
    card: 'Chart',
    map: 'Map',
    keyWord: 'Please enter key words',
    refresh: 'Refresh',
    add: 'Add',
    delete: 'Delete',
    deviceName: 'Device name',
    remark: 'Remark',
    resolution: 'Resolution',
    types: 'Types',
    version: 'Version number',
    status: 'Status',
    operate: 'Operate',
    edit: 'Modify',
    loading: 'Loading',
    allSelect: 'Select all spread',
    selected: 'Selected',
    selectAll: 'Select all on this page',
    selectInMap: 'Please select device location on map',
    structure: 'Structure',
    selectGroup: 'Select structure',
    selectSize: 'Please select resolution',
    customize: 'Customize',
    selectSn: 'Please select SN',
    deviceTip: 'Device name cannot empty',
    snTip: 'SN cannot be empty',
    sizeTip: 'Screen resolution cannot be empty',
    deviceType: 'Device type',
    cancel: 'Cancel',
    confirm: 'Confirm',
    delDevice: 'Delete terminal',
    delDevTip: 'Permanently delete the selected terminal?',
    onlineTotal: 'Online Statistics',
    reboot: 'Reboot',
    offscreen: 'Turn off screen',
    onscreen: 'Turn on screen',
    timeTask: 'Timing command',
    conBright: 'Bright adjust',
    conVoice: 'Sound adjust',
    relay: 'Relay switch',
    timeZone: 'Time zone calibration',
    signalChange: 'Signal switching',
    synScreen: 'Multi-screen synchronization',
    timePlay: 'Timing play switch',
    timeOn: 'Timingswitch',
    wTip: 'Resolution W is empty',
    hTip: 'Resolution H is empty',
    xTip: 'Position X is empty',
    yTip: 'Position y is empty',
    mapTip: 'Zoom out on the map to check the table information! ! !',
    selectTip: 'No device selected',
    deviceDetail: 'Device Details',
    playList: 'Program list',
    affi: 'Affiliation:',
    screenType: 'Screen type',
    boxTime: 'Box clock',
    noData: 'No data',
    currTimeZone: 'Current time zone',
    deviceLan: 'Device language',
    deviceZoom: 'Storage',
    runState: 'Run status',
    runTime: 'Continue run',
    lastHeart: 'Recent heartbeat',
    timeOrder: 'Timing command',
    comAddr: 'Server address',
    voice: 'Sound',
    birght: 'Brightness',
    no: 'Coding',
    proName: 'Program Name',
    power: 'Relay',
    milRefresh: 'Seconds, auto refresh',
    viewPho: 'View original photo',
    setTimeZone: 'Set time zone',
    terminalUp: 'Terminal upgrade',
    upType: 'Upgrade method',
    cloudUp: 'Cloud upgrade',
    localUp: 'Local file upgrade',
    clickUp: 'Click to upload',
    name: 'Name',
    type: 'Model',
    verInfo: 'Version Information',
    schedule: 'Schedule',
    noUp: 'No need upgrade',
    waitStar: 'Wait start',
    downExc: 'Download exception',
    downOK: 'Download success',
    upTip: 'Upgrading, will restart auto when complete',
    checkError: 'validators fail',
    erroBack: 'Abnormal feedback',
    downError: 'Download fail',
    dowNum: '1 selected',
    upTips1: 'Note: In order to prevent data loss, please backup data, the device will restart auto after upgrade is completed,',
    upTips2: 'please do not power off during upgrade process',
    upGr: 'Upgrade',
    serverAddEdit: 'Server address modify',
    serEdTit: 'Remove terminal to the new server',
    newAddr: 'New server address',
    test: 'Test',
    user: 'User',
    psw: 'Password',
    remove: 'Remove',
    conRes: 'Confirm restart',
    conOnSc: 'Confirm open screen',
    upTips3: 'Please use zip or apk file',
    testOk: 'Test passed',
    testFail: 'Test failed',
    inputTips1: 'Please fill in username and password',
    opOk: 'Operate success',
    mapTip1: 'Please mark device location on map',
    addDetail: 'Details address',
    lng: 'Longitude',
    lat: 'Latitude',
    matTip2: 'Failed to get address, please try later',
    orderTip: 'Confirm restart selected terminal screen?',
    orderTip1: 'Confirm close selected terminal screen?',
    orderTip2: 'Confirm to open selected terminal screen?',
    scSetting: 'Schedule settings',
    selectTip1: 'Please select at least two programs',
    selectTip2: 'Add timing command',
    selectTip3: 'Please select template action data',
    conOrder: 'Operation commander',
    action1: 'Program switch',
    action2: 'Bright adjust',
    action3: 'Volume adjust',
    action4: 'Turn off screen',
    action5: 'Turn on screen',
    action6: 'Source switch',
    action7: 'Relay off',
    action8: 'Relay on',
    action9: 'Turn off screen',
    action10: 'Turn on screen',
    value: 'value',
    acVa1: 'HDMI priority',
    acVa2: 'Async signal',
    acVa3: 'Sync signal',
    excTime: 'Execution time',
    dateOk: 'Valid date',
    noLimit: 'No limit',
    isWeekLi: 'Valid week',
    oper: 'Operate',
    newTem: 'Create template',
    savTem: 'Save template',
    addTem: 'add scheduling template',
    temName: 'Template name',
    temTip1: 'Please enter template name',
    relayOn: 'Relay switch',
    timeZoneSe: 'Time zone selection',
    hdmiSi: 'HDMI signal source',
    inSin: 'Internal signal source',
    openMulti: 'Enable multi-screen Sync playback',
    gps: 'GPS Sync',
    localW: 'LAN sync',
    closeScreen: 'Turn off multi-screen sync playback',
    openTimePlay: 'Turn on timing playback',
    closeTimePlay: 'Turn off timing playback',
    openTime: 'Turn on timing',
    onTime: 'boot time',
    offTime: 'Shutdown time',
    excDate: 'Execution date',
    closeTime: 'Close timing',
    onlyG: 'Only supports advertising machine devices',
    Sunday: 'Sunday',
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday',
    noDeviceSelected: 'No device selected',
    group: 'Mechanism',
    onlineNum: 'Online Qty',
    offlineNum: 'Offline Qty',
    totalNum: 'Device Qty',
    noOrderExc: 'No commands have been executed yet',
    createTime: 'Submission time',
    orderName: 'Command name',
    aimDevice: 'Target device',
    orderStatus: 'Command status',
    timeOut: 'Timeout feedback',
    excSuccess: 'Execution succeed',
    sent: 'Sent',
    timeOpenNo: 'Timing switch: no data yet',
    timeOpen: 'Timing switch: on',
    deviceOff: 'Device offline',
    timeOpenTip: 'Timing playback is on',
    timeCloseTip: 'Timing playback is off',
    programList: 'Program list',
    playTime: 'Program duration',
    loop: 'Loop',
    excSta: 'Executive standard',
    timingPlay: 'Timing play',
    playCount: 'Times of play',
    proDelete: 'Delete program',
    proDeleteTip: 'Delete the program?',
    timePlayOpenTip: 'Timing playback start success',
    timePlayCloseTip: 'Timing playback close success',
    programChangeTip: 'Program switch success',
    programIsPlaying: 'Program is playing',
    powerList: 'Onboard power supply',
    allOpen: 'All open',
    allClose: 'All close',
    open: 'Open',
    close: 'Close',
    mulCard: 'Multi function card',
    firstChannel: 'First channel',
    secondChannel: 'Second channel',
    thirdChannel: 'Third channel',
    fourthChannel: 'Fourth channel',
    fifthChannel: 'Fifth channel',
    sixthChannel: 'Sixth channel',
    seventhChannel: 'Seventh channel',
    eighthChannel: 'Eighth channel',
    syncToTerminal: 'Sync to terminal',
    allOpenTip: 'Turn on/off the multifunction card?',
    operComman: 'Operation command',
    brigValue: 'Volume',
    method: 'Method',
    speDate: 'Specified date',
    speWeek: 'Specified week',
    isDateLimit: 'Is there a date limit?',
    isWeekLimit: 'Whether week limit',
    edits: 'Edit',
    timingOn: 'Timing command on',
    timingOff: 'Timing command off',
    addTimingCom: 'Add timing command',
    ban: 'Forbidden',
    opend: 'Open',
    closed: 'Close',
    timePlayTips: 'Timed playback, unable to switch',
    addDevice: 'Add device',
    deviceTypeTip: 'Please select device type',
    key: 'Key',
    groupTips: 'Organization structure cannot be empty',
    least: 'Remaining',
    arrangeTip: 'Please select between 0-100',
    saveSuccess: 'Save success',
    tempExit: 'Template already exists, please change the name',
    command: 'Command',
    isSent: 'Sent to',
    execSuccess: 'execution succeed',
    sented: 'Sent to',
    execFail: 'Timeout feedback',
    runStatus: 'Online & On Screen & On Play',
    timeLimit: 'Please space',
    timeLimitTip: 'Seconds, and then do the operation, there is still left',
    seconds: 'Second',
    syncPlay: 'Play in sync',
    signalStatus: 'Signal source state',
    automatic: '自动',
    zh: '简体中文',
    en: '英语',
    vn: '越南语',
    isopend: 'Now on',
    isclosed: 'Not open',
    syncGps: 'GPS同步',
    syncNet: '网络同步',
    snTipLan: "Please enter capital letters and numbers",
    batchAdd: "batch add",
    batchUpdate: "batch upgrading",
    live: "Real-time streaming",
    camera: "camera",
    currentStreamAddress: "Current stream address：",
    setParameters: "Set Parameters",
    tips1: "Get playback real-time picture",
    tips2: "Current stream address：",
    buttonCopy: "Copy ",
    Resolution: "Resolution",
    FrameRate: "Frame rate",
    CentralControl: "Central control control",
  },
  PE: {
    ...en.programEditing
  }
}